// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as PorterStoreProductEntityMapper from "../entity-mapper/PorterStoreProductEntityMapper.bs.js";
import * as PorterStoreProductDetailEntityMapper from "../entity-mapper/PorterStoreProductDetailEntityMapper.bs.js";

var execute = PorterStoreProductEntityMapper.execute;

var PorterStoreProductListConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var PorterStoreProductListResponseConverter = partial_arg(PorterStoreProductListConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = PorterStoreProductDetailEntityMapper.execute;

var PorterStoreProductDetailConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var PorterStoreProductDetailResponseConverter = partial_arg$1(PorterStoreProductDetailConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  PorterStoreProductListConfig ,
  PorterStoreProductListResponseConverter ,
  PorterStoreProductDetailConfig ,
  PorterStoreProductDetailResponseConverter ,
  
}
/* PorterStoreProductListResponseConverter Not a pure module */
